// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo[data-v-2a189b81]{height:150px;width:150px}@media(min-width:600px){.logo[data-v-2a189b81]{height:250px;width:250px}}.socials[data-v-2a189b81]{display:flex;justify-content:space-around}@media(min-width:600px){.socials[data-v-2a189b81]{justify-content:flex-start}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
